import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// A freestanding control / mimic panel: a sloped operator console on a cabinet
// base, with a mimic diagram of coloured bars and indicator lamps, two screens
// and a row of switches. The human interface to a switchroom.
const CABINET = "#7c8288";
const CABINET_DK = "#5f656b";
const FACE = "#3a4046";
const SCREEN = "#2a6f9e";
const MIMIC = "#b87333";
const LAMP_G = "#3fae5a";
const LAMP_R = "#c4392f";

export const controlPanel = defineModel({
  id: "control-panel",
  batchId: "electric",
  name: "Control panel",
  tags: ["prop", "electric", "power", "control", "switchgear"],
  summary: "An operator console with a mimic diagram, screens and switches.",
  footprint: 0.4,
  parts(): Part[] {
    const parts: Part[] = [
      // Cabinet base.
      { geometry: new THREE.BoxGeometry(0.7, 0.6, 0.34), color: CABINET, position: [0, 0.3, 0] },
      { geometry: new THREE.BoxGeometry(0.72, 0.05, 0.36), color: CABINET_DK, position: [0, 0.62, 0] },
      // Sloped operator face.
      { geometry: new THREE.BoxGeometry(0.7, 0.04, 0.3), color: FACE, position: [0, 0.66, 0.06], rotation: [-0.6, 0, 0] },
      // Two screens on the upright back panel.
      { geometry: new THREE.BoxGeometry(0.66, 0.34, 0.04), color: CABINET_DK, position: [0, 0.86, -0.12] },
      { geometry: new THREE.BoxGeometry(0.24, 0.18, 0.02), color: SCREEN, position: [-0.16, 0.9, -0.1] },
      { geometry: new THREE.BoxGeometry(0.24, 0.18, 0.02), color: SCREEN, position: [0.16, 0.9, -0.1] },
      // Mimic diagram bars on the sloped face.
      { geometry: new THREE.BoxGeometry(0.4, 0.02, 0.02), color: MIMIC, position: [-0.08, 0.7, 0.12], rotation: [-0.6, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.02, 0.02, 0.14), color: MIMIC, position: [0.12, 0.69, 0.1], rotation: [-0.6, 0, 0] },
    ];
    // Indicator lamps and switches across the face.
    const lamps = [LAMP_G, LAMP_R, LAMP_G, LAMP_R];
    lamps.forEach((c, i) => {
      parts.push({ geometry: new THREE.CylinderGeometry(0.018, 0.018, 0.02, 8), color: c, position: [-0.27 + i * 0.12, 0.715, 0.16], rotation: [-0.6, 0, 0] });
      parts.push({ geometry: new THREE.BoxGeometry(0.03, 0.02, 0.04), color: "#cfcfcf", position: [-0.27 + i * 0.12, 0.66, 0.22], rotation: [-0.6, 0, 0] });
    });
    return parts;
  },
  animations: [],
});
